import React, { useState, useContext } from 'react';
import Navbar from '../layouts/navbar';
import Parse from 'parse';
import swal from 'sweetalert';
import { AuthContext } from '../../auth';
import {Redirect} from 'react-router-dom';
import {Link} from 'react-router-dom';


export const Register = () => {
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [cpassword, setCpassword] = useState('');
    const [logedinuser, setLogedinuser] = useContext(AuthContext);
    const [registered, setregistered] = useState('false');
    let display;

    // const renderRedirect = () => {
    //     return <Redirect to='/login' />
    // }


    const handleSubmit = (e) => {
        e.preventDefault();
         
        console.log("submit called");
        const user = new Parse.User();
        console.log(name);
        console.log(password);
        if (password !== cpassword) {
            swal("Oops!", "Password dont match :(", "error");
        } else {

            user.set("username", name);
            user.set("name", name);
            user.set("password", password);
            user.set("cpassword", cpassword);
            user.set("isCounsellor", true);
            user.signUp()
                .then((data) => {
                    console.log(data);
                    setName("");
                    setPassword("");
                    setCpassword("");
                    
                    swal("Addedd!", "User successfully added", "success");
                    setregistered("true");

                }).catch((error) => {
                    // console.log(error);
                    swal("Oops!", "no user..wrong email or password", "error");
                    // alert(error);
                })
        }

        
    }


    return (
        <div>
            {console.log(registered,"register")}
            {(registered === "true") && (
                <Redirect to="/counsellor/login"/>
            )
        }

            <Navbar head="Register" />
            {console.log(logedinuser,"called")}
            {(logedinuser != null) && (
                <Redirect to="/counsellor/login" />
            )}
            <div className="container cnt">
                <form onSubmit={handleSubmit}>
                    <h1 className="head1">Create an Account</h1>
                    <div className="row ">
                        <div className="form-group  col-lg-12  ">
                            <input type="text"
                                className="form-control "
                                id="usr"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                placeholder="user name" />
                        </div>
                        <div className="form-group col-lg-12  ">
                            <input type="password"
                                className="form-control"
                                id="pwd"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                placeholder="Password" />
                        </div>
                        <div className="form-group col-lg-12  ">
                            <input type="password"
                                className="form-control"
                                id="pwd2"
                                value={cpassword}
                                onChange={e => setCpassword(e.target.value)}
                                placeholder="Confirm Password" />
                        </div>
                        <div className="col-lg-12  policy">
                            <p><Link to="/forum">Terms and condition and privacy policy</Link></p>
                            {display}
                        </div>

                    </div>
                    {/* <input
                        type="submit"
                            className="submit btn-primary center-block mt-4" /> */}
                    <div className="btndiv">
                        <button type="submit" class="authbtn btn-primary mt-4">Submit</button>
                    </div>
                </form>
                <div className="signupdiv">Already have an account? <br /><Link to="/counsellor/login">click here to Login</Link></div>
            </div>
        </div>
    );
};



export default Register;


